import {
  DAWN_AT,
  NIGHT_END,
  PALETTE_TOKENS,
  type PaletteToken,
  SUN_PALETTES,
  type SunPalette,
  paletteAt,
} from '../shared/palette';

const MIN_FRACTION_STEP = 0.01;

// No text colour holds 4.5:1 on the mid grey between night and dawn: the interface switches halfway, a step, not a dip.
export function uiPaletteAt(fraction: number): SunPalette {
  if (fraction > NIGHT_END && fraction < DAWN_AT) {
    const half = (NIGHT_END + DAWN_AT) / 2;
    return SUN_PALETTES[fraction < half ? 'nuit' : 'aube'];
  }
  return paletteAt(fraction);
}

export function cssName(token: PaletteToken): string {
  return `--${token.replace(/[A-Z]/g, (letter) => `-${letter.toLowerCase()}`)}`;
}

interface Styled {
  readonly style: {
    setProperty(name: string, value: string): void;
    removeProperty(name: string): unknown;
  };
}

export function applyPalette(target: Styled, palette: SunPalette): void {
  for (const token of PALETTE_TOKENS) {
    target.style.setProperty(cssName(token), palette[token]);
  }
}

export interface SunFollower {
  follow(fraction: number): void;
  fix(moment: 'nuit' | 'jour'): void;
  clear(): void;
}

// Only when the set time moved by more than a hundredth.
export function createSunFollower(target: Styled): SunFollower {
  let applied: number | null = null;
  return {
    follow(fraction) {
      if (applied !== null && Math.abs(fraction - applied) <= MIN_FRACTION_STEP) {
        return;
      }
      applied = fraction;
      applyPalette(target, uiPaletteAt(fraction));
    },
    clear() {
      applied = null;
      for (const token of PALETTE_TOKENS) {
        target.style.removeProperty(cssName(token));
      }
    },
    fix(moment) {
      applied = null;
      applyPalette(target, SUN_PALETTES[moment]);
    },
  };
}
